export default __webpack_public_path__ + "static/media/nyspot.2f5cde28.png";